import { Stack } from "@mui/material";
import React from "react";
import MessageContainer from "components/chat/MessageContainer";
import MarkdownBlock from "components/react-lib/markdown-code/MarkdownBlock";
import CopyButton from "components/react-lib/generic-ui/CopyButton";
import { useTheme } from "@emotion/react";
import { fonts } from "fonts";
import { useDispatch } from "react-redux";
import { popupActions } from "store/react-lib/generic-ui/popup";
import DownloadableImage from "components/chat/DownloadableImage";

export default function TextMessage({
  message,
  isLive,
  inContext,
  noMenu,
  renderContainer = true,
  canDelete = true,
  canUseAsPrompt = true,
}) {

  const dispatch = useDispatch();
  const theme = useTheme();

  const renderBottomContent = () => {
    if (isLive) return null;
    return <CopyButton color="white" />;
  };

  const renderContent = () => {
    return (
      <>
        <MarkdownBlock
          markdownContent={message.content}
          canCopyCode={true}
          rawTextColor={theme.palette.text.main}
          rawCopyButtonColor={theme.palette.text.main}
          style={{
            color: theme.palette.text.main,
            lineHeight: 1.5,
            fontFamily: fonts.geist,
            overflowX: "auto",
          }}
          onCopy={() => dispatch(popupActions.showSuccess("Copied"))}
        />
        {message.image && (
          <Stack alignItems="center" justifyContent="center">
            {/* <img
              src={message.image}
              alt=""
              style={{
                width: "200px",
                borderRadius: "10px",
              }}
            /> */}
            <DownloadableImage imageSrc={message.image} />
          </Stack>
        )}
      </>
    );
  };

  if(!renderContainer) return renderContent();

  return (
    <MessageContainer
      key={message.id}
      message={message}
      isLive={isLive}
      bottomContent={renderBottomContent()}
      inContext={inContext}
      noMenu={noMenu}
      canDelete={canDelete}
      canUseAsPrompt={canUseAsPrompt}
    >
      {renderContent()}
    </MessageContainer>
  );
}
